import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux"; // Redux Provider
import { BrowserRouter as Router } from "react-router-dom"; // React Router for routing
import store from "./redux/store"; // Redux store
import App from "./App"; // The main App component

import "./index.css"; // Your global styles

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    {" "}
    {/* Provide the Redux store to the entire app */}
    <React.StrictMode>
      <App /> {/* Main App component */}
    </React.StrictMode>
  </Provider>
);
